import React from 'react';

const Tile = ({ label, value, sub, accent, testId }) => (
  <div
    data-testid={testId}
    className={`p-7 border ${
      accent
        ? 'bg-[#7C9CB1] text-[#F4F8F9] border-[#7C9CB1]'
        : 'bg-[#F4F8F9] border-[#C1D7E2] text-[#7C9CB1]'
    }`}
  >
    <p
      className={`font-mono text-[10px] tracking-[0.3em] uppercase mb-4 ${
        accent ? 'text-[#F4F8F9]/80' : 'text-[#90B0BF]'
      }`}
    >
      {label}
    </p>
    <p className="font-serif text-4xl md:text-5xl font-light leading-none">{value}</p>
    {sub && (
      <p
        className={`mt-3 font-mono text-[11px] tracking-[0.2em] ${
          accent ? 'text-[#F4F8F9]/80' : 'text-[#90B0BF]'
        }`}
      >
        {sub}
      </p>
    )}
  </div>
);

const StatsBlock = ({ partner, totals }) => (
  <section
    data-testid="partner-stats"
    className="grid grid-cols-2 md:grid-cols-4 gap-6"
  >
    <Tile
      accent
      testId="partner-stat-seva"
      label="$SEVA balance"
      value={Number(partner.seva_balance || 0).toFixed(2)}
      sub="Redeemable for bulk units"
    />
    <Tile
      testId="partner-stat-refills"
      label="Verified refills"
      value={totals.refills_verified}
      sub={`${totals.refills_count} attempts · ${totals.ml_refilled.toFixed(0)}ml`}
    />
    <Tile
      testId="partner-stat-dispensed"
      label="ml dispensed"
      value={totals.ml_dispensed.toFixed(0)}
      sub={`${totals.usage_events} pay-per-use events`}
    />
    <Tile
      testId="partner-stat-orders"
      label="Bulk orders"
      value={totals.bulk_orders_count}
      sub={`$${totals.bulk_orders_total_usd.toFixed(2)} lifetime`}
    />
  </section>
);

export default StatsBlock;
